import { render, staticRenderFns } from "./SingleExpert.vue?vue&type=template&id=32f231a6&scoped=true"
import script from "./SingleExpert.vue?vue&type=script&lang=js"
export * from "./SingleExpert.vue?vue&type=script&lang=js"
import style0 from "./SingleExpert.vue?vue&type=style&index=0&id=32f231a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f231a6",
  null
  
)

export default component.exports